// Temporarily hidden at the user's request; keep the cards available for later.
export const dashboardCardVisibility = {
  ciiRatings: false,
  inPortConsumption: false,
  criticalEvents: false,
}
